"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("chart-custom__tooltip");
var TOOLTIP_TEXT_MAPPING = {
    Draft: (react_1.default.createElement(react_1.default.Fragment, null,
        "Draft pages created ",
        react_1.default.createElement("span", { className: "italic" }, "before"),
        " the current time period.")),
    Live: (react_1.default.createElement(react_1.default.Fragment, null,
        "Pages changed to live ",
        react_1.default.createElement("span", { className: "italic" }, "before"),
        " the current time period.")),
    Accepted: (react_1.default.createElement(react_1.default.Fragment, null,
        "Pages accepted ",
        react_1.default.createElement("span", { className: "italic" }, "before"),
        " the current time period.")),
    Declined: (react_1.default.createElement(react_1.default.Fragment, null,
        "Pages declined ",
        react_1.default.createElement("span", { className: "italic" }, "before"),
        " the current time period.")),
};
function BarTooltipPageCountBottom(props) {
    var tooltipPayload = props.tooltipPayload, xAxisName = props.xAxisName;
    var _a = __read(tooltipPayload, 1), value = _a[0].value;
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Label, { align: "center", theme: "dark", className: c("header") },
            value,
            " old ",
            xAxisName,
            " ",
            value === 1 ? "page" : "pages"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "center", theme: "dark" }, TOOLTIP_TEXT_MAPPING[xAxisName])));
}
exports.default = BarTooltipPageCountBottom;
